<template>
  <v-sheet
    width="100%"
    height="100%"
    color="grey lighten-4"
    class="d-flex align-center justify-center py-8 py-md-12 py-lg-16"
  >
    <v-container>
      <div class="d-flex flex-column align-center">
        <v-icon :size="xs ? 40 : 56" color="success"> fa-check-circle </v-icon>

        <div
          class="
            grey--text
            text--darken-3 text-h5 text-sm-h4 text-md-h3 text-lg-h2
            font-weight-bold
            text-center
            mt-4
          "
        >
          Obrigado!
        </div>

        <div
          class="grey--text text--darken-2 text-h6 text-md-h5 text-center mt-10"
        >
          {{ $route.meta.text }}
        </div>

        <div class="text-center">
          <v-btn
            color="primary"
            :to="$route.meta.to"
            height="auto"
            class="
              text-body-1
              font-weight-bold
              text-none
              mt-10
              py-3
              px-7 px-md-10
            "
            depressed
            tile
          >
            <v-icon class="mr-4" size="16"> fa-long-arrow-left </v-icon>
            Voltar
          </v-btn>
        </div>
      </div>
    </v-container>
  </v-sheet>
</template>

<script>
export default {
  computed: {
    sm() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    xs() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
};
</script>
